// /config/util/date.js


export function formatDate(date, format = 'YYYY-MM-DD') {
    // 使用 dayjs 或者自定义实现日期格式化
    return dayjs(date).format(format);
}
